/// <reference types="store" />
import storeEngine from 'store/src/store-engine';
import cookieStore from 'store/storages/cookieStorage';
import localStore from 'store/storages/localStorage';
import memoryStore from 'store/storages/memoryStorage';

const store = storeEngine.createStore([cookieStore, localStore, memoryStore]);

type Listener<T> = (value: T | null | undefined) => void;

const listeners: Record<string, Listener<any>[]> = {};

const keyChange = <T>(key: string, data: T) => {
  const callbacks = key in listeners ? listeners[key] : [];
  callbacks.forEach((fn) => fn(data));
};

const subscribeToKey = <T>(key: string, fn: Listener<T>) => {
  if (!(key in listeners)) {
    listeners[key] = [];
  }

  listeners[key].push(fn);

  fn(store.get(key));

  const unsubscribe = () => {
    listeners[key] = listeners[key].filter((o) => o !== fn);
  };

  return unsubscribe;
};

const set = <T>(key: string, data: T) => {
  store.set(key, data);
  keyChange(key, data);
};

const get = <T>(key: string): T | undefined => {
  return store.get(key);
};

const remove = (key: string) => {
  store.remove(key);
  keyChange(key, undefined);
};

const refreshSubscriptions = () => {
  Object.keys(listeners).forEach((key) => keyChange(key, store.get(key)));
};

const clear = () => {
  store.clearAll();
  refreshSubscriptions();
};

export const AuthStorage = {
  subscribeToKey,
  set,
  get,
  remove,
  clear,
  refreshSubscriptions,
};
